import { useEffect, useState } from 'react'
import { useParams } from 'wouter'

import { FullPageLoader } from '@/components/FullPageLoader'
import { NotFound } from '@/pages/NotFound'

import { EsumOfferView } from './EsumOfferView'
import { esumVariants } from './variants'

const DEEPLINK_SPINNER_MS = 1500

export function EsumOffer() {
  const { id } = useParams<{ id: string }>()
  const variant = esumVariants[id]
  const [isOpeningDeeplink, setIsOpeningDeeplink] = useState(!!variant)

  useEffect(() => {
    if (!variant) return

    window.location.href = variant.deeplink

    const timer = setTimeout(
      () => setIsOpeningDeeplink(false),
      DEEPLINK_SPINNER_MS,
    )
    return () => clearTimeout(timer)
  }, [variant])

  if (!variant) return <NotFound />

  if (isOpeningDeeplink) {
    return <FullPageLoader />
  }

  return <EsumOfferView {...variant} />
}
